import { useCallback, useState } from 'react';
import DatePicker from 'react-datepicker';
import { CY_SELECTORS } from '../../cypress/constants';
import { COMMON_DATE_TIME_FORMAT, COMMON_DATE_TIME_UTC_FORMAT, DATE_TIME_PICKER_INTERVAL, MONTH_ONLY_DATE_FORMAT } from '../commons/constants/constants';
import dayjs from '../commons/utils/dayjsUtils';
import { addCypressSelector } from '../commons/utils/utils';
interface EditableDateTimePickerProps {
  label: string;
  placeholder: string;
  selectedDateTime: string | null;
  handleDateChange: (value: Date | null | string, id: string) => void;
  error?: string;
  id: string;
  minDate?: Date;
  maxDate?: Date;
  isDisabled?: boolean;
  isMonthOnly?: boolean;
  description?: string;
  isTypingDisabled?: boolean;
}
const EditableDateTimePicker = ({
  label,
  selectedDateTime,
  handleDateChange,
  placeholder,
  error,
  id,
  minDate,
  maxDate,
  isDisabled,
  isMonthOnly = false,
  description,
  isTypingDisabled = false
}: EditableDateTimePickerProps) => {
  const [showError, setShowError] = useState(false);
  const handleMouseEnter = (): void => {
    if (error) setShowError(true);
  };
  const handleMouseLeave = (): void => {
    setShowError(false);
  };
  const handleChange = (date: Date | null): void => {
    if (date) {
      const formattedDate = dayjs(date).format(COMMON_DATE_TIME_UTC_FORMAT);
      handleDateChange(formattedDate, id);
    } else {
      handleDateChange(null, id);
    }
  };
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
    if (isTypingDisabled) {
      e.preventDefault();
    }
  }, [isTypingDisabled]);
  return <div className='flex flex-col' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-sentry-component="EditableDateTimePicker" data-sentry-source-file="EditableDateTimePicker.tsx">
      <label htmlFor={id}>{label}</label>
      {description && <p className='text-[#6B7280] text-sm'>{description}</p>}
      <DatePicker className={`p-1 pl-2 border border-gray-200 rounded-lg w-full mt-1 text-gray-500 h-9 ${error ? 'border-rose-500' : ''}`} id={id} selected={selectedDateTime ? dayjs(selectedDateTime.slice(0, -1)).toDate() : null} onChange={handleChange} placeholderText={placeholder} dateFormat={isMonthOnly ? MONTH_ONLY_DATE_FORMAT : COMMON_DATE_TIME_FORMAT} timeIntervals={DATE_TIME_PICKER_INTERVAL} showTimeSelect={!isMonthOnly} isClearable minDate={minDate} maxDate={maxDate} disabled={isDisabled} showMonthYearPicker={isMonthOnly} onKeyDown={handleKeyDown} data-sentry-element="DatePicker" data-sentry-source-file="EditableDateTimePicker.tsx" />
      {showError && error && <p {...addCypressSelector(CY_SELECTORS.DATE_PICKER_ERROR_MSG)} className='text-red-500 text-sm'>
          {error}
        </p>}
    </div>;
};
export default EditableDateTimePicker;